var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "device-log" }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "refresh-data" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设备ID/UUID" } },
                [
                  _c("el-input", {
                    ref: "deviceIdInput",
                    staticClass: "serach",
                    attrs: { placeholder: "请输入设备ID/UUID", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.queryInfo.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.deviceIdOrUid,
                      callback: function ($$v) {
                        _vm.deviceIdOrUid = $$v
                      },
                      expression: "deviceIdOrUid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "自动刷新" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      on: { change: _vm.handleTimeInterval },
                      model: {
                        value: _vm.timeInterval,
                        callback: function ($$v) {
                          _vm.timeInterval = $$v
                        },
                        expression: "timeInterval",
                      },
                    },
                    _vm._l(_vm.timeOptions, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.label, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "add-btn",
                      attrs: { type: "primary", size: "14" },
                      on: { click: _vm.refreshData },
                    },
                    [_vm._v("\n            刷新数据\n          ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "device-info-section" }, [
      _c("div", { staticClass: "info-cards" }, [
        _c("div", { staticClass: "info-card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c(
              "div",
              {
                staticClass: "card-icon",
                class: {
                  "device-icon": !!_vm.deviceInfo.productImage,
                },
              },
              [
                _c("img", {
                  attrs: {
                    width: "50",
                    src: _vm.deviceInfo.productImage || _vm.productImage,
                  },
                }),
              ]
            ),
            _c("h3", [_vm._v("设备标识")]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("设备ID：")]),
            _c("span", [_vm._v(_vm._s(_vm.deviceInfo.deviceId))]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("设备UUID：")]),
            _c("span", [_vm._v(_vm._s(_vm.deviceInfo.deviceUuid))]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("设备名称：")]),
            _c("span", [_vm._v(_vm._s(_vm.deviceInfo.deviceName))]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("产品ID：")]),
            _c("span", [_vm._v(_vm._s(_vm.deviceInfo.productId))]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("产品名称：")]),
            _c("span", [_vm._v(_vm._s(_vm.deviceInfo.productName))]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("设备类型：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.deviceInfo.deviceType === "1"
                    ? "子设备"
                    : _vm.deviceInfo.deviceType === "0"
                    ? "网关设备"
                    : ""
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("归属网关ID：")]),
            _c("span", [_vm._v(_vm._s(_vm.deviceInfo.gatewayId))]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("归属网关：")]),
            _c("span", [
              _vm._v(
                _vm._s(_vm.deviceInfo.gatewayName) +
                  _vm._s(
                    _vm.deviceInfo.gatewayProductId
                      ? "(" + _vm.deviceInfo.gatewayProductId + ")"
                      : ""
                  )
              ),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "info-card" },
          [
            _vm._m(1),
            _c("div", { staticClass: "device-property" }, [
              _c("label", [_vm._v("在线状态：")]),
              _c("span", { staticClass: "status on" }, [
                _vm._v(
                  _vm._s(
                    _vm.deviceStatus.state === "online"
                      ? "在线"
                      : _vm.deviceStatus.state === "offline"
                      ? "离线"
                      : ""
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "device-property" }, [
              _c("label", [_vm._v("状态更新时间：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.deviceStatus.updateStateTimestamp &&
                      _vm.formatTimestamp(_vm.deviceStatus.updateStateTimestamp)
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "device-property" }, [
              _c("label", [_vm._v("信号强度：")]),
              _c("span", [_vm._v(_vm._s(_vm.deviceStatus.signal))]),
            ]),
            _c("div", { staticClass: "device-property" }, [
              _c("label", [_vm._v("ZIGBEE版本：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.deviceStatus.otaInfoList &&
                      _vm.deviceStatus.otaInfoList.length &&
                      _vm.deviceStatus.otaInfoList[0].efirmwareName
                  )
                ),
              ]),
            ]),
            _vm._l(_vm.deviceStatus.otaInfoList, function (item, i) {
              return _c("div", { key: i, staticClass: "device-property" }, [
                _c("label", [_vm._v(_vm._s(item.efirmwareName) + "版本：")]),
                _c("span", [
                  _vm._v(
                    "\n            " + _vm._s(item.version) + "\n            "
                  ),
                  item.version !== item.newVersion
                    ? _c("span", [
                        _vm._v(
                          "\n              （有新版本: " +
                            _vm._s(item.newVersion) +
                            "）\n            "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            }),
          ],
          2
        ),
        _c("div", { staticClass: "info-card" }, [
          _vm._m(2),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("所属家庭：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  (_vm.deviceSpace.spaceName || "") +
                    (_vm.deviceSpace.spaceId
                      ? "(" + _vm.deviceSpace.spaceId + ")"
                      : "")
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("所属房间：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  (_vm.deviceSpace.roomName || "") +
                    (_vm.deviceSpace.roomId
                      ? "(" + _vm.deviceSpace.roomId + ")"
                      : "")
                )
              ),
            ]),
          ]),
          _c("div", { staticClass: "device-property" }, [
            _c("label", [_vm._v("家庭所有者：")]),
            _c("span", [
              _vm._v(
                _vm._s(
                  (_vm.deviceSpace.ownerPhone || "") +
                    (_vm.deviceSpace.ownerId
                      ? "(" + _vm.deviceSpace.ownerId + ")"
                      : "")
                )
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._m(3),
    _c(
      "div",
      { staticClass: "tabs" },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "div",
          {
            key: tab.index,
            staticClass: "tab-pane",
            class: { "tab-active": _vm.activeName === tab.index },
            on: {
              click: function ($event) {
                return _vm.handleTabs(tab.index)
              },
            },
          },
          [
            _c("div", { staticClass: "tab-box" }, [
              _c("span", { staticClass: "tab-title" }, [
                _vm._v(_vm._s(tab.title)),
              ]),
            ]),
          ]
        )
      }),
      0
    ),
    _c(
      "div",
      { staticClass: "contain" },
      [
        _c(_vm.activeTabComponent, {
          ref: "activeComponentRef",
          tag: "component",
          attrs: {
            exist: _vm.exist,
            "device-id-or-uid": _vm.deviceId,
            "device-id": _vm.deviceId,
            "device-type": _vm.deviceInfo && _vm.deviceInfo.deviceType,
            "query-info": _vm.queryInfo,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("i", { staticClass: "fas fa-server" }),
      _vm._v(" 设备日志管理系统\n    "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "card-icon" }, [
        _vm._v("\n            📶\n          "),
      ]),
      _c("h3", [_vm._v("设备状态")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "card-icon" }, [
        _vm._v("\n            🏠\n          "),
      ]),
      _c("h3", [_vm._v("归属信息")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "note" }, [
      _c("i", { staticClass: "fas fa-info-circle" }),
      _c("div", [
        _c("strong", [_vm._v("说明：")]),
        _vm._v("数据存储时间为14天，支持日志数据导出。\n    "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }